import { createFileRoute } from "@tanstack/react-router";
import { AppointmentsPage } from "@/modules/appointments/presentation/pages/AppointmentsPage";

export const Route = createFileRoute("/_authenticated/appointments")({
  component: AppointmentsPage,
});
